export default __webpack_public_path__ + "static/media/dummy-graph.eb055642.png";